var _path, _ellipse, _ellipse2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMondayCrmSquare = function SvgMondayCrmSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A0A0",
    d: "M44.957 34.957c.047.664-.495 1.205-1.157 1.205H29.324c-.662 0-1.204.54-1.157 1.205a17.13 17.13 0 0 0 3.788 9.603 16.85 16.85 0 0 0 9.753 5.902c3.829.769 7.804.174 11.247-1.684a16.98 16.98 0 0 0 7.635-8.506 17.2 17.2 0 0 0 .558-11.466 17.02 17.02 0 0 0-6.773-9.22 16.75 16.75 0 0 0-14.427-2.09 16.8 16.8 0 0 0-3.425 1.514 16.96 16.96 0 0 1 6.236 6.34l.005-.073q.016.03.034.06a17.16 17.16 0 0 1 2.16 7.21"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.125,
    cy: 36.162,
    fill: "#fff",
    rx: 16.875,
    ry: 17.037
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.125,
    cy: 36.162,
    fill: "url(#paint0_linear_1371_406869)",
    rx: 16.875,
    ry: 17.037
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_1371_406869)",
    d: "M36.566 50.919A17.06 17.06 0 0 0 45 36.162a10 10 0 0 0-.043-1.205 1.15 1.15 0 0 1-1.157 1.205H29.324c-.662 0-1.204.54-1.157 1.205a17.13 17.13 0 0 0 3.788 9.603 16.9 16.9 0 0 0 4.61 3.949"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1371_406869",
    x1: 16.389,
    x2: 45.113,
    y1: 25.935,
    y2: 40.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D2D2",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1371_406869",
    x1: 46.831,
    x2: 19.974,
    y1: 44.955,
    y2: 39.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D2D2"
  })))));
};
export default SvgMondayCrmSquare;